import React from 'react'
import Carousel from '../carousel';
import InstagramPost from './instagram-post';

const InstagramFeed = ({
  heading = 'In Your Diggs', 
  description = 'Share your photos with #DiggsPet and tag us @DiggsPet on IG and TikTok.', 
  instaPosts, 
  sliderSettings = {
    animateOnHover: false,
    arrows: true,
    autoplay: false,
    centerMode: false,
    centerPadding: 0,
    dots: false,
    focusOnSelect: true,
    infinite: false,
    initialSlide: 0,
    pauseOnHover: false,
    rtl: false,
    slidesToScroll: 1,
    slidesToShow: {
      desktop: 4,
      mobile: 1.3,
    },
    speed: 500,
    swipe: true,
    swipeToSlide: true,
    variableWidth: false,
    vertical: false,
    _type: "slidesToShow",
  }
}) => {
  return (
    <Carousel heading={heading} description={description} settings={sliderSettings}>
      {instaPosts?.map((data, index) => (
        <InstagramPost key={index} {...data} />
      ))}
    </Carousel>
  )
}

export default InstagramFeed